import { Link, useLocation } from "react-router-dom";
import { useSession } from "../lib/session";
import ThemeToggle from "./ThemeToggle";

export default function TopBar(): JSX.Element {
  const user = useSession((s) => s.user);
  const location = useLocation();
  // Hide the right-side SIGN IN button when we're already on /login —
  // a second "Sign in" CTA there is redundant and dilutes the page focus.
  const onLogin = location.pathname === "/login";
  return (
    <header className="topbar">
      <Link to="/" className="topbar-brand" aria-label="SubsWall home">
        <span className="topbar-mark" aria-hidden="true">T</span>
        <span className="topbar-word">SUBSWALL</span>
      </Link>
      <nav className="topbar-nav">
        <ThemeToggle />
        {user ? (
          <Link to="/dashboard" className="btn">{user.display_name}</Link>
        ) : onLogin ? null : (
          <Link to="/login" className="btn btn-primary">Sign in</Link>
        )}
      </nav>
      <style>{`
        .topbar {
          display: flex; align-items: center; justify-content: space-between;
          padding: 14px 24px;
          gap: 12px;
          border-bottom: 1px solid var(--border, #2a2a3d);
          background: var(--surface, #16161f);
        }
        .topbar-brand {
          display: inline-flex; align-items: center; gap: 12px;
          text-decoration: none; color: inherit;
          flex-shrink: 1; min-width: 0;
          overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
        }
        .topbar-mark {
          width: 38px; height: 38px;
          display: grid; place-items: center;
          background: var(--bits, #9146FF);
          border-radius: 9px; color: #fff;
          font-family: var(--f-display, "Tomorrow", system-ui, sans-serif);
          font-weight: 800; font-size: 22px; line-height: 1;
          box-shadow: 0 0 16px #9146FFaa, 0 0 0 1px #ffffff14 inset;
          flex-shrink: 0;
        }
        .topbar-word {
          font-family: var(--f-display, "Tomorrow", system-ui, sans-serif);
          font-weight: 800; font-size: 20px;
          letter-spacing: .08em;
          text-shadow: 0 0 12px #9146FFaa, 0 0 24px #9146FF44;
          color: var(--text-pri, #fff);
        }
        @media (max-width: 540px) {
          .topbar { padding: 12px 14px; gap: 8px; }
          .topbar-mark { width: 34px; height: 34px; border-radius: 8px; font-size: 19px; }
          .topbar-word { font-size: 17px; letter-spacing: .06em; }
          .topbar-nav { gap: 6px; }
          .topbar-nav .btn { padding: 8px 10px; font-size: 12px; }
        }
        @media (max-width: 380px) {
          .topbar-word { display: none; }
        }
        .topbar-nav {
          display: flex; gap: 10px; align-items: center;
          flex-shrink: 0; flex-wrap: nowrap;
        }
        .topbar-nav .btn { flex-shrink: 0; white-space: nowrap; }
        /* In light theme the heavy purple glow can wash out — soften it. */
        [data-theme="light"] .topbar-word {
          color: #0E0E10;
          text-shadow: 0 0 12px #9146FF44;
        }
      `}</style>
    </header>
  );
}
